import { ProductSelection } from '@moncler/components/product';
import ProductImage from '@moncler/components/product/ProductImage';
import { ProductActionTypes } from '@state/features/common.types';
import { MD, SM, XXS } from '@utils/imageutils';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
const LookProduct = (props) => {
    let dispatch;
    if (!props.noRedux) {
        dispatch = useDispatch();
    }
    const [selectedLook, setSelectedLook] = useState(props.products[0]);
    useEffect(() => {
        if (!props.noRedux && selectedLook && props.showLook) {
            dispatch({
                type: ProductActionTypes.FETCH_PRODUCT,
                payload: {
                    pid: selectedLook.id,
                },
            });
        }
    }, [selectedLook, props.showLook, props.noRedux]);
    const productSlide = (el, i) => {
        return (React.createElement("button", { key: i, className: classNames('products-selector__slide', { selected: el === selectedLook }), onClick: () => setSelectedLook(el) },
            React.createElement(ProductImage, { productId: el.id, img: el.imgs, sizes: [XXS, SM, MD], type: "F" })));
    };
    if (props.noRedux) {
        return (React.createElement("div", { className: "product-reserve" },
            React.createElement("div", { className: "product-reserve__main" },
                React.createElement("p", { className: "product-reserve__main__name" }, props === null || props === void 0 ? void 0 : props.title),
                React.createElement(ProductImage, { productId: selectedLook.id, img: selectedLook.imgs, sizes: [XXS, SM, MD], type: "F" }),
                props.products.length > 5 ? (React.createElement(Swiper, { onAfterInit: (swipr) => setTimeout(() => swipr.el.classList.add('right-overlay'), 100), className: "products-selector--carousel", spaceBetween: 4, slidesPerView: 5, grabCursor: true, freeMode: true, onSlideChange: (swipr) => {
                        if (swipr.activeIndex > 0) {
                            swipr.el.classList.add('left-overlay');
                        }
                        else {
                            swipr.el.classList.remove('left-overlay');
                        }
                        if (swipr.activeIndex + 5 < props.products.length) {
                            swipr.el.classList.add('right-overlay');
                        }
                        else {
                            swipr.el.classList.remove('right-overlay');
                        }
                    } }, props.products.map((el, i) => (React.createElement(SwiperSlide, { key: i }, productSlide(el, i)))))) : (React.createElement("div", { className: "products-selector" }, props.products.map((el, i) => productSlide(el, i))))),
            React.createElement("div", { className: "product-reserve__detail" },
                React.createElement(ProductSelection, { currentLook: selectedLook, contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl }))));
    }
    return (React.createElement("div", { className: "row justify-center" },
        React.createElement("div", { className: "col-md-10 col-lg-8" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-6 preview-image" },
                    React.createElement(ProductImage, { productId: selectedLook.id, img: selectedLook.imgs, sizes: [XXS, SM, MD], type: "F" })),
                React.createElement("div", { className: "col-sm-6 look-products" },
                    React.createElement(ProductSelection, { currentLook: selectedLook, shopTheLook: true, inverted: true }),
                    props.products.length > 5 ? (React.createElement(Swiper, { onAfterInit: (swipr) => setTimeout(() => swipr.el.classList.add('right-overlay'), 100), className: "products-selector--carousel", spaceBetween: 4, slidesPerView: 5, grabCursor: true, freeMode: true, onSlideChange: (swipr) => {
                            if (swipr.activeIndex > 0) {
                                swipr.el.classList.add('left-overlay');
                            }
                            else {
                                swipr.el.classList.remove('left-overlay');
                            }
                            if (swipr.activeIndex + 5 < props.products.length) {
                                swipr.el.classList.add('right-overlay');
                            }
                            else {
                                swipr.el.classList.remove('right-overlay');
                            }
                        } }, props.products.map((el, i) => (React.createElement(SwiperSlide, { key: i }, productSlide(el, i)))))) : (React.createElement("div", { className: "products-selector" }, props.products.map((el, i) => productSlide(el, i)))))))));
};
export default LookProduct;
